import React from "react";
import "./ProductGrid.css";
import ProductCard from "../ProductSlider/ProductCard";

export default function ProductGrid({products}) {
    return (
        <div className="product-grid">
            {products && products.map((product) => (
                <ProductCard key={product._id} product={product} />
            ))}
        </div>
    );
}

